export enum AvailabilityTemplateSubPartKind {
  SupplierAvailability = 1
}